import React, { useContext } from 'react'
import Notes from './Notes';
import userContext from '../context/Users/UserContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export const Home = (props) => {
    let navigate = useNavigate();

    const context = useContext(userContext);
    const { isauthenticated } = context

    useEffect(() => {
        if (!isauthenticated) {
            navigate('/');
        }
    }, [])

    return (
        <>
            <div className="container my-5 border shadow rounded p-5" style={{width:"90%"}}>
                <Notes showalert={props.showalert} />
            </div>
        </>
    )

}

export default Home;